module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "387",
      "src": "images/f0029-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_vm._v("GOOD-BY, OLD TIMER")])]), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("T")])]), _vm._v("HE NIGHT was noiseless except for the wind and the river. A few sparks gleamed in the fire, like fallen stars. Brighty edged closer to the dying glow. The sand felt warm and scratchy to his skin as he lay squirming on his back, his hoofs pawing at the chink of sky between the canyon walls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a time the moon showed itself and gradually, very gradually, began whitewashing rocks and promontories. It whitened Brighty’s belly, too, and his nose as he lay blinking upward. At last he snuggled into the nest he had made in the sand. He closed his eyes and let sleep claim him while the wind played with his scraggly mane.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("All night long the wind and the river went on about their business, sweeping down the canyon. Sounds came through Brighty’s sleep—the voices of coyotes and foxes, and the occasional ringing sound of a rock tumbling from crag to crag. But all of this was canyon music to Brighty, and he slept on in the friendly darkness.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Toward morning his thirst awakened him, and he took off for Bright Angel Creek, a small gray shadow winding among the deeper shadows of morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was burro-brush on his way, and he stopped to browse here and there until his thirst pulled him on to the chattering creek. He waded far upstream, up where the water flowed so clear he could see trout darting under the rocks. He drank his fill—not in one long draught, but a little here, then up the creek a way and another mouthful, until he was satisfied. Sometimes he stood quite still, letting the water foam and feather around his legs. But more often he got into a rough-and-tumble fight with it, pawing madly until he churned whirlpools and eddies. Then he stood over it like a victor, blowing and snorting as he watched the sand settle to the bottom again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bright Angel Creek seemed to flow especially for him, to quench his thirst and wash his feet, and to grow willows and grasses that stayed green for him, no matter what.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morning passed. The whole day passed, while Brighty played in the creek and browsed alongside it. Only occasionally he clambered over the rocks and up the stern granite walls to get away from its gushing chatter. But always he hurried back, as to an old friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the coming of twilight, however, the babble of the creek seemed idle nonsense. He felt a need for human company. Somewhere in the shadows far below a nice old man would be stirring biscuits or hot cakes. A hunger and a longing came to him, and he clattered out upon the rocks to a parapet that looked down on the campsite. There! He spotted the white tent, no bigger than a deer tail. He worked himself into a bray that sounded loud and clear. When the last echo had died, he waited, listening. But there was no answer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 87
// module chunks = 0